import styled from 'styled-components';

export const ReactGridEditorContainer = styled.div`
  margin-top: 1rem;
  border: 1px solid ${(props) => props.theme.colors.elementsInputBorder};
  border-radius: 4px;
  overflow: hidden;
`;

export const ReactGridEditorLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background-color: ${(props) => props.theme.colors.secondaryLightGreen30};
  ${(props) => props.theme.typography.contentTableTitleXs}

  span {
    font-weight: 400;
    color: ${(props) => props.theme.colors.statusLabelGrayText};
    font-style: italic;
  }
`;

export const ReactGridEditorGridWrapper = styled.div`
  overflow-x: auto;

  .reactgrid-content {
    ${(props) => props.theme.typography.contentTableBodyXs}
  }

  /* Header cells - green like the grid above */
  .rg-cell.rg-header-cell {
    background: ${(props) => props.theme.colors.secondaryLightGreen30} !important;
    ${(props) => props.theme.typography.contentTableTitleXs}
  }

  /* Non-editable data cells (indicator name, unit) */
  .rg-cell.rg-cell-noneditable {
    background-color: ${(props) => props.theme.colors.elementsTableRow};
  }

  /* Editable data cells */
  .rg-cell.rg-text-cell:not(.rg-cell-noneditable):not(.rg-header-cell) {
    background-color: ${(props) => props.theme.colors.primaryWhite};
  }

  /* Error cells - red triangle in top-right corner (Excel-style) */
  .rg-cell.rg-cell-error {
    // position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 8px 8px 0;
      border-color: transparent ${(props) => props.theme.colors.systemStatusError} transparent transparent;
    }

    &:hover::before {
      content: 'Validation error';
      position: absolute;
      top: -28px;
      right: 0;
      background-color: ${(props) => props.theme.colors.statusLabelRedBg};
      color: ${(props) => props.theme.colors.statusLabelRedText};
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 11px;
      white-space: nowrap;
      z-index: 10;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    }
  }
`;
